export default __webpack_public_path__ + "static/media/emailBlue.6cfccd99.svg";